import React from 'react';
import Typography from '@mui/material/Typography';
import useStyles from './styles';
import * as IconMUI from '@mui/icons-material';

const Callout = (props: CalloutProps) => {
  const { children } = props;
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <IconMUI.Info className={classes.icon} />
      <Typography variant="body2" className={classes.text} component="span">
        {children}
      </Typography>
    </div>
  );
};

export type CalloutProps = {
  children: React.ReactNode;
};

export default Callout;
